import { Text } from '@user-portal/wikr-components';

import { selectCurrentUser } from 'store/user/selectors';

import { accountTabs, TABS } from './constants';

import { useSelector } from 'hooks/store';

import { Tabs } from 'components/Tabs';
import SubscriptionsTab from 'components/SubscriptionsTab';
import SettingsTab from 'components/SettingsTab';
import ProfileTab from 'components/ProfileTab';

import * as S from './styled';

import FemaleAvatar from 'assets/img/svg/avatarWoman.svg';
import MaleAvatar from 'assets/images/avatar.svg';

interface IAccountSettings {
    tabId?: string;
    onChangeTab: (tabId: string) => void;
}

const getCurrentTab = (currentTab: string) => {
    switch (currentTab) {
        case accountTabs.Subscription:
            return <SubscriptionsTab />;

        case accountTabs.Settings:
            return <SettingsTab />;

        default:
            return <ProfileTab />;
    }
};

const AccountSettings = ({ tabId, onChangeTab }: IAccountSettings) => {
    const currentUser = useSelector(selectCurrentUser);
    const currentTabId = tabId || accountTabs.Profile;

    return (
        <>
            <S.Container>
                {currentUser?.name && currentUser?.last_name && (
                    <S.AvatarWrapper $paddingTop={48} $paddingBottom={16} $paddingX={16}>
                        {currentUser?.gender === 'female' ? <FemaleAvatar /> : <MaleAvatar />}
                        <Text type="h5">{`${currentUser.name} ${currentUser.last_name}`}</Text>
                    </S.AvatarWrapper>
                )}
                <S.ContentWrapper>
                    <Tabs tabs={TABS} currentTab={currentTabId} onChange={onChangeTab} />
                </S.ContentWrapper>
            </S.Container>
            <S.ContentWrapper $paddingX={16}>{getCurrentTab(currentTabId)}</S.ContentWrapper>
        </>
    );
};

export default AccountSettings;
